import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Flex, Heading, HStack, VStack, Stack, Text, Box, Image, Link, Spinner, Button } from "@chakra-ui/react";
import { InfoIcon } from '@chakra-ui/icons';
import { BiFilter } from "react-icons/bi";
import { GrFormDown } from "react-icons/gr";
import CommonVars from "../components/CommonVars";
import LargeStarRating from "../components/LargeStarRatings";
import SmallStarRating from "../components/SmallStarRatings";
import axios from "axios";

function ReviewsScreen() {
    const productid = parseInt(useParams().productid);
    const [avgRating, setAvgRating] = useState(0);
    const [totalReviews, setTotalReviews] = useState(0);
    const [reviews, setReviews] = useState('');
    const [noReviews, setNoReviews] = useState(false);
    const [loading, setLoading] = useState(false);

    // access backend to retrieve total and average rating
    const getReviewSummary = async () => {
        axios.get(`${CommonVars.API_URL}/product/${productid}/review-summary/`)
        .then((res) => {
            if (res.data[0] === undefined) {
                setTotalReviews(0);
                setAvgRating(0);
                setLoading(true);
            } else {
                setAvgRating(res.data[0].averagerating);
                setTotalReviews(res.data[0].totalreviews);
                setLoading(true);
            }
        })
        .catch((error) => {
            console.log(error);
        });
    }
    // access backend to retrieve all reviews for product
    const getAllReviews = async () => {
        axios.get(`${CommonVars.API_URL}/product/${productid}/reviews/`)
        .then((res) => {
            setNoReviews(true);
            setReviews(res.data);
        })
        .catch((error) => {
            console.log(error);
        });
    }

    useEffect(() => {
        getReviewSummary();
        getAllReviews();
    });

    const pdtReviews = [];
    for (let i=0; i < reviews.length; i++) {
        pdtReviews.push(
            <Box
                key={reviews[i].review_id}
                bg="white"
                rounded="lg"
                shadow="sm"
                width={{ base: 'full', sm: 'xl', lg: '3xl' }}
                p={4}
            >
                <Box 
                    borderBottomWidth={1}
                    borderStyle={'solid'}
                    borderColor={'gray.200'}
                    pb={2}
                >
                    <HStack justify="space-between">
                        <Text fontWeight='semibold' color='#616161'>{reviews[i].username}</Text>
                        <Text color="grey">{reviews[i].date}</Text>
                    </HStack>
                </Box>
                <Box pt={2}>
                    <SmallStarRating rating={reviews[i].rating}/>
                    <Text pb={3} pt={1}>{reviews[i].review}</Text>
                    {
                        reviews[i].review_img_url !== "" ? 
                        <Box p={2} rounded='md' width={{sm: '40%', md: '29%', lg: '29%'}} bg={'#F4F4F4'}>
                            <Image boxSize='200px' borderRadius='md' objectFit='cover' src={reviews[i].review_img_url} alt={`Image of ${reviews[i].name}`}/>
                        </Box> : null
                    }
                </Box>
            </Box>
        )
    }

    return (
        <Flex 
            minH={'100vh'}
            justify={'center'}
            bg={'#F4F4F4'}
        >
            {loading !== true ? 
                <Flex align={'center'} justify={'center'}>
                    <VStack align="center">
                            <Spinner thickness='9px' speed='0.75s' emptyColor='gray.200' color='blue.500' boxSize={24}/>
                            <Text fontSize={18} pt={6}>Loading Reviews...</Text>
                    </VStack>
                </Flex> : 
                <>
                {noReviews === true && totalReviews === 0 ?
                    <Flex align={'center'} justify={'center'}>
                        <Box textAlign="center" py={10} px={6}>
                            <InfoIcon boxSize={'50px'} color={'blue.500'} />
                            <Heading as="h2" size="xl" mt={6} mb={2}>
                                No reviews yet!
                            </Heading>
                            <Text color={'gray.500'}>
                                No reviews have been added for this product yet.
                            </Text>
                            <Box pt={8}>
                                <a href="/products">
                                    <Button
                                        colorScheme="blue"
                                        bgGradient="linear(to-r, blue.400, blue.500, blue.600)"
                                        color="white"
                                        variant="solid"
                                    >
                                        Back to Shopping
                                    </Button>
                                </a>
                            </Box>
                        </Box>
                    </Flex>
                    : 
                    <Flex>
                        <VStack pt={20} pb={8}>
                            <Stack align="center" pb={6}>
                                <Heading fontSize="xl">Customer Reviews</Heading>
                                <HStack>
                                    <Text fontSize='5xl' fontWeight="bold">{avgRating}</Text>
                                    <Text pt={6}>/ 5.0</Text>
                                </HStack>
                                <LargeStarRating rating={avgRating} />
                                <Link href={`/product/${productid}/reviews`}><Text>based on {totalReviews} review{totalReviews > 1 && 's'}</Text></Link>
                            </Stack>
                            <VStack align="flex-start" spacing={3}>
                                <Box pb={1}>
                                    <div className="dropdown">
                                        <HStack>
                                            <BiFilter size={26} />
                                            <button className="dropbtn">Filter by ratings</button>
                                            <GrFormDown />
                                        </HStack>
                                        <div className="dropdown-content">
                                            <a href={`/product/${productid}/rating-search?rating=1`}>1 Star</a>
                                            <a href={`/product/${productid}/rating-search?rating=2`}>2 Stars</a>
                                            <a href={`/product/${productid}/rating-search?rating=3`}>3 Stars</a>
                                            <a href={`/product/${productid}/rating-search?rating=4`}>4 Stars</a>
                                            <a href={`/product/${productid}/rating-search?rating=5`}>5 Stars</a>
                                            <a href={`/product/${productid}/reviews`}>View all</a>
                                        </div>
                                    </div>
                                </Box>
                                {pdtReviews}
                            </VStack>
                        </VStack>
                    </Flex>
                } 
                </>
            }
        </Flex>
    )
}

export default ReviewsScreen;